import * as ProjectApiService from './ProjectApiService';
import { IDynamicProjectGetData } from '../api/IApiResponse';
import { logDebug, logError } from '../utils/utils';

/**
 * Fetches a project by its GUID from the new backend API.
 * This replaces the old BeMaccaferriStoreProvider.getDynamicProjectAsync()
 * to use the new unified ProjectApiService.
 *
 * @param guid - The GUID of the project to fetch.
 * @returns A promise that resolves to the project data.
 */
export const getProject = async (guid: string): Promise<IDynamicProjectGetData> => {
    try {
        logDebug('DynamicProjectService', `🔄 Loading project from new API: ${guid}`);

        const result = await ProjectApiService.loadProjectByGuid(guid);

        if (!result.success || !result.data) {
            throw new Error(result.error || 'Failed to load project from backend');
        }

        // Transform backend format to frontend format
        const frontendProject = ProjectApiService.transformProjectFromBackend(result.data);

        logDebug('DynamicProjectService', '✅ Project loaded and transformed successfully:', {
            guid: frontendProject.guid,
            unit: frontendProject.unit,
            method: frontendProject.method,
        });

        return frontendProject as IDynamicProjectGetData;
    } catch (error) {
        logError('DynamicProjectService', '❌ Error loading project from new API:', error);
        throw error;
    }
};
